import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Suspense as _Suspense, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-d8278328")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 col-12 mb-4" }
const _hoisted_3 = { class: "col-md-6 col-12" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Loading..")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PartnerStatusAlert = _resolveComponent("PartnerStatusAlert")!
  const _component_PlanFromCatalogSelector = _resolveComponent("PlanFromCatalogSelector")!
  const _component_ProductSummaryCard = _resolveComponent("ProductSummaryCard")!
  const _component_ProductCheckout = _resolveComponent("ProductCheckout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_RegistrationSummary = _resolveComponent("RegistrationSummary")!
  const _component_ForceToCreatePartnerProperties = _resolveComponent("ForceToCreatePartnerProperties")!
  const _component_RequireToAcceptTerms = _resolveComponent("RequireToAcceptTerms")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_PartnerStatusAlert),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.arePartnerCatalogsForFlatRateEnabled)
                ? (_openBlock(), _createBlock(_component_PlanFromCatalogSelector, {
                    key: 0,
                    "plan-category": _ctx.FLAT_RATE_PLAN
                  }, null, 8, ["plan-category"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.arePartnerCatalogsForFlatRateEnabled)
                ? (_openBlock(), _createBlock(_component_ProductSummaryCard, {
                    key: 0,
                    onCallToAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.triggerProductRegistering()))
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      fallback: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })),
    (_ctx.goToProductCheckout)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ProductCheckout, {
              "coverage-selection": _ctx.coverageSelection.plans,
              discounts: [],
              onCancelRegistration: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelProductRegistration())),
              "plan-category": _ctx.FLAT_RATE_PLAN
            }, null, 8, ["coverage-selection", "plan-category"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!!_ctx.registrationSummary)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_RegistrationSummary)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.forceToCreatePartnerProperties)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_ForceToCreatePartnerProperties)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.requireToAcceptTerms)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_RequireToAcceptTerms)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}